"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubRisqueRendementAccepter = void 0;
exports.ESubRisqueRendementAccepter = {
    null: "null",
    faible: "faible",
    moyen: "moyen",
    eleve: "eleve",
};
